import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FulfilmentStoreStockLevelResponse } from '@woolworthsnz/trader-api';
import { IconFill, IconSize, SentenceCasePipe, SvgIconComponent } from '@woolworthsnz/styleguide';
import { NgClass, NgIf } from '@angular/common';
import StockLevelEnum = FulfilmentStoreStockLevelResponse.StockLevelEnum;

type InfoColors = 'green' | 'orange' | 'red';

@Component({
	selector: 'wnz-product-stock-level-indicator',
	templateUrl: './product-stock-level-indicator.component.html',
	styleUrls: ['./product-stock-level-indicator.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [SvgIconComponent, NgClass, NgIf, SentenceCasePipe],
})
export class ProductStockLevelIndicatorComponent {
	@Input()
	get stockLevel(): StockLevelEnum {
		return this._stockLevel;
	}

	set stockLevel(value: StockLevelEnum) {
		this._stockLevel = value;

		switch (value) {
			case StockLevelEnum.InStock:
				this.iconName = 'green-checked-filled';
				this.iconFill = 'green';
				this.infoColor = 'green';
				break;

			case StockLevelEnum.Unknown:
			case StockLevelEnum.LowStock:
				this.iconName = 'alert-filled';
				this.iconFill = 'warning';
				this.infoColor = 'orange';
				break;

			case StockLevelEnum.NoStock:
				this.iconName = 'close-filled';
				this.iconFill = 'error';
				this.infoColor = 'red';
				break;
		}

		this.stockLevelName = value
			.replace(/([A-Z])/g, ' $1')
			.trim()
			.toLowerCase();
	}

	// eslint-disable-next-line @typescript-eslint/naming-convention
	private _stockLevel: StockLevelEnum = StockLevelEnum.Unknown;

	@Input() storeName?: string;
	@Input() storeAddress?: string;
	@Input() iconSize: IconSize = 'very-small';

	iconName = 'close';
	iconFill: IconFill = 'warning';
	infoColor: InfoColors = 'orange';
	stockLevelName = StockLevelEnum.Unknown.toString();
}
